import { render, staticRenderFns } from "./InvalidNotification.vue?vue&type=template&id=44f10cf2&scoped=true"
import script from "./InvalidNotification.vue?vue&type=script&lang=js"
export * from "./InvalidNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f10cf2",
  null
  
)

export default component.exports